import { Routes } from '@angular/router';
import { TicketGuard } from './guards/ticket.guard';
import { TicketPageComponent } from './features/ticket-purchase/components/main-ticket-page/main-ticket-page.component';
import { PaymentAcceptComponent } from './features/payment/components/payment-accept/payment-accept.component';
import { PaymentCancelComponent } from './features/payment/components/payment-cancel/payment-cancel.component';
import { OrderPageComponent } from './features/ticket-inspection/components/main-order-page/main-order-page.component';
import { ExternalRedirectGuard } from './guards/external-redirect.guard';

export const routes: Routes = [
  {
    path: 'eventticket/:id',
    component: TicketPageComponent,
    canActivate: [TicketGuard]
  },
  {
    path: 'eventticket',
    redirectTo: 'https://www.help.com',
    pathMatch: 'full'
  },
  {
    path: 'specialticket/:id/payment/:orderId/accept',
    component: PaymentAcceptComponent
  },
  {
    path: 'specialticket/:id/payment/:orderId/cancel',
    component: PaymentCancelComponent
  },
  {
    path: 'orders/:id',
    component: OrderPageComponent,
    canActivate: [TicketGuard]
  },
  {
    path: '**',
    canActivate: [ExternalRedirectGuard],
    component: TicketPageComponent
  }
];
